<template>
    <cell-card class="coupon-main">

    </cell-card>
</template>

<script>
import CellCard from "@/components/CellCard.vue";
import {Row, Col} from "vant";
export default {
    name: "coupon",
    components: {
        [CellCard.name]: CellCard,
        [Row.name]: Row,
        [Col.name]: Col
    },
    data() {
        return {};
    }
}
</script>

<style lang="less">

</style>